import {get, post, put, _delete, patch } from './Tools';

const getEmpleados = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.nomina_need_timesheets !== undefined && params.nomina_need_timesheets !== null) {
    query.append('nomina_need_timesheets', String(params.nomina_need_timesheets));
  }
  const queryString = query.toString();
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/list${queryString ? `?${queryString}` : ''}`);
  return response;
};

const getEmpleadosActivos = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.nomina_need_timesheets !== undefined && params.nomina_need_timesheets !== null) {
    query.append('nomina_need_timesheets', String(params.nomina_need_timesheets));
  }
  const queryString = query.toString();
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/activos${queryString ? `?${queryString}` : ''}`);
  return response;
};

const getEmpleadosByPeriodId = async (period_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/list/${period_id}`);
  return response;
};

const getEmpleadosByPeriodoNomina = async (period_id, anio, num_periodo, scope = 'procesar') => {
  const query = new URLSearchParams();
  if (scope) query.append('scope', scope);
  const queryString = query.toString();
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/list/periodo/${period_id}/${anio}/${num_periodo}${queryString ? `?${queryString}` : ''}`);
  return response;
};

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados`);
  return response;
};

const getEmpleadoById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/${id}`);
  return response;
};

const updateById = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo/empleados`, payload);
  return response;
};

const createEmpleado = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo/empleados`, payload);
  return response;
};

const getCompaniesList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_compania/get/list`);
  return response;
};

const getAllCompanies = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_compania/get/list`);
  return response;
};

const getCompanyById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_compania/${id}`);
  return response;
};

const getCompanyByOdooId = async (odoo_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_compania/odoo/${odoo_id}`);
  return response;
};

const updateCompany = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_compania`, payload);
  return response;
};

const updateCompanyPassword = async (payload) => {
  const response = await patch (`${process.env.REACT_APP_SERVER}odoo_compania/password`, payload);
  return response;
};

const getAllSupervisores = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/supervisores`);
  return response;
};

const getEmpleadosDeSupervisor = async (supervisor_odoo_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/supervisores/${supervisor_odoo_id}`);
  return response;
};

const getMotivosBajaList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}motivos_baja/get/list`);
  return response;
};

const darBajaEmpleado = async (empleadoId, payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo/empleados/baja/${empleadoId}`, payload);
  return response;
};

const recontratarEmpleado = async (empleadoId, payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo/empleados/rehire/${empleadoId}`, payload);
  return response;
};

const editarEmpleado = async (empleadoId, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo/empleados/edit/${empleadoId}`, payload);
  return response;
};

const actualizarFotoEmpleado = async (empleadoId, foto) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo/empleados/${empleadoId}/foto`, { foto });
  return response;
};

const importEmpleadosBulk = async (file, force_save = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('force_save', force_save ? 1 : 0);

  const token = localStorage.getItem('token');

  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}odoo/empleados/import`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
      },
      body: formData,
    });

    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const importEmpleadosConfirm = async (cached_records) => {
  const token = localStorage.getItem('token');

  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}odoo/empleados/import/confirm`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        cached_records
      }),
    });

    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const previewImportEmpleados = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const token = localStorage.getItem('token');

  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}odoo/empleados/import/preview`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
      },
      body: formData,
    });

    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const createMissingCatalogs = async ({ departamentos, puestos, areas, tipos_contrato, horarios, periodos }) => {
  const token = localStorage.getItem('token');

  try {
    const result = await fetch(`${process.env.REACT_APP_SERVER}odoo/empleados/import/create-missing`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-access-token': '1',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ departamentos, puestos, areas, tipos_contrato, horarios, periodos }),
    });

    const data = await result.json();
    return data;
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

const getNominaRegimenSalarialList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}nomina_regimen_salarial/list`);
  return response;
};

const getOdooHorarioList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_horario/get/list`);
  return response;
};

const getTipoContratoList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}tipo_contrato/get/list`);
  return response;
};

const getPaises = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_pais/get/list`);
  return response;
};

const getEstadosByPais = async (paisId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_estado/by-pais/${paisId}`);
  return response;
};

export { 
  getEmpleados,
  getEmpleadosActivos,
  getEmpleadosByPeriodId,
  getEmpleadosByPeriodoNomina,
  getAll,
  getEmpleadoById, 
  createEmpleado,
  updateById,   
  getCompaniesList, 
  getAllCompanies, 
  getCompanyById, 
  getCompanyByOdooId, 
  updateCompany,
  updateCompanyPassword,
  getAllSupervisores,
  getEmpleadosDeSupervisor,
  getMotivosBajaList,
  darBajaEmpleado,
  recontratarEmpleado,
  editarEmpleado,
  getNominaRegimenSalarialList,
  getOdooHorarioList,
  getTipoContratoList,
  getPaises,
  getEstadosByPais,
  actualizarFotoEmpleado,
  importEmpleadosBulk,
  importEmpleadosConfirm,
  previewImportEmpleados,
  createMissingCatalogs
};
